import { Link } from "react-router-dom";
import { footerContact, footerItem, socialIcons } from "../data/Data";
import Newsletter from "../home/Newsletter";

export default function Footer() {
  return (
    <>
      <Newsletter />
      <div
        className="container-fluid bg-dark text-light footer wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container pb-5">
          <div className="row g-5">
            <div className="col-md-6 col-lg-4">
              <div className="bg-primary rounded p-4">
                <Link to="/">
                  <h1 className="text-white text-uppercase mb-3">Sampath Residency</h1><img
                    src="/assets/img/logo.jpg"
                    alt="Sampath Residency Logo"
                    className="img-fluid"
                    style={{ maxHeight: "50px", marginRight: "10px" }}
                  />
                </Link>
                <p className="text-white mb-0">
                  SAMPATH RESIDENCY A/C boarding & lodging is a modern posh, luxury hotel, situated in the Very close to Palani Bus stand & Palani Hill Temple
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <h6 className="section-title text-start text-primary text-uppercase mb-4">
                Contact
              </h6>
              {footerContact.map((val, index) => (
                <p className="mb-2" key={index}>
                  {val.icon}
                  <a href={`tel:${val.contact}`} style={{ textDecoration: "none" }}> {val.name}</a>
                </p>
              ))}
              <div className="d-flex pt-2">
                {socialIcons.slice(0, 4).map((val, index) => (
                  <a
                    key={index}
                    className="btn btn-outline-light btn-social me-2"
                    href={val.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="social link"
                  >
                    {val.icon}
                  </a>
                ))}
              </div>

            </div>
            <div className="col-lg-5 col-md-12">
              <div className="row gy-5 g-4">
                {footerItem.map((section, sectionIndex) => (
                  <div className="col-md-6" key={sectionIndex}>
                    <h6 className="section-title text-start text-primary text-uppercase mb-4">
                      {section.header}
                    </h6>
                    {section.UnitItem.map((item, itemIndex) => (
                      <Link
                        key={itemIndex}
                        to={item.to} // Using the explicit 'to' value here
                        className="btn btn-link"
                      >
                        {item.name}
                      </Link>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="copyright">
            <div className="row">
              <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                &copy; <Link className="border-bottom" to="/">Sampath Residency</Link>, All Right Reserved.
              </div>
              <div className="col-md-6 text-center text-md-end">
                Created By <a className="border-bottom" href="https://www.ruthradigitalsolutions.com" target="_blank" rel="noopener noreferrer">Ruthra Digital Solutions</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
